import { render, staticRenderFns } from "./TrainingStepModelRelease.vue?vue&type=template&id=1ba92068&scoped=true&"
import script from "./TrainingStepModelRelease.vue?vue&type=script&lang=js&"
export * from "./TrainingStepModelRelease.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStepModelRelease.vue?vue&type=style&index=0&id=1ba92068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba92068",
  null
  
)

export default component.exports